/**
 * The gallery's shipped sample pictures (spec 027 D-18), one per ready-made
 * style, made by `npm run looks:samples` in `Service` and imported so Vite
 * fingerprints them. `samples.json` beside them records how each was made.
 */
import type { LookPresetId } from '../../../../Shared/src/images';
import anime from '../../assets/looks/anime.webp';
import chibi from '../../assets/looks/chibi.webp';
import clay from '../../assets/looks/clay.webp';
import comic from '../../assets/looks/comic.webp';
import corporate from '../../assets/looks/corporate.webp';
import cutout from '../../assets/looks/cutout.webp';
import flat from '../../assets/looks/flat.webp';
import ink from '../../assets/looks/ink.webp';
import painterly from '../../assets/looks/painterly.webp';
import pixel from '../../assets/looks/pixel.webp';
import sketch from '../../assets/looks/sketch.webp';
import watercolour from '../../assets/looks/watercolour.webp';

export const LOOK_SAMPLE_URLS: Readonly<Record<LookPresetId, string>> = {
  corporate, flat, ink, watercolour, sketch, cutout, clay, comic, anime, chibi, painterly, pixel,
};
